import { type ReactElement } from 'react';
import { type ArticleContent } from 'types/wellbeing';
import { STYLES } from '../../styles';
import { processTextWithBold } from '../../utils';
import BulletsList from '../Bullets/BulletList';

interface ParagraphContentProps {
  contentItem: ArticleContent;
}

const ParagraphContent = ({ contentItem }: ParagraphContentProps): ReactElement => (
  <div className={STYLES.PARAGRAPH_CONTAINER}>
    <p className={STYLES.PARAGRAPH}>{processTextWithBold(contentItem.text || '')}</p>
    {contentItem.type === 'BULLETS' && <BulletsList bullets={contentItem.items || []} />}
  </div>
);

export default ParagraphContent;
